// extracted by mini-css-extract-plugin
export default {"fee":"CalcFees_fee__3EWuV","bold":"CalcFees_bold__JJHaq"};